import { useEffect } from "react";
import Nav from "@/sections/Nav";
import Footer from "@/sections/Footer";
import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";
import { Award } from "lucide-react";

const CREDENTIALS = [
  { source: "OSHAcademy (earned by exam)", items: ["CSHM", "CSHP", "CSSS", "CSHS", "CSHT"] },
  { source: "TSTC", items: ["CPR", "OSHA 30", "HAZWOPER", "Certificates in Construction Safety and Environmental Compliance"] },
  { source: "OSHA 30", items: ["Construction and General Industry"] },
  { source: "CPR / First Aid / AED", items: ["Current certification"] },
];

export default function ServicesPage() {
  useEffect(() => {
    document.title = "Services — WSafe AI by WorkSafeAgent";
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView(), 400);
    }
  }, []);

  return (
    <div className="bg-white text-ink font-sans antialiased min-h-screen">
      <Nav />
      <main className="pt-36 pb-24">
        <div className="mx-auto max-w-[1160px] px-6">
          <Chapter eyebrow="Services" title="A person on top of the software." />

          <section id="compliance" className="scroll-mt-24 mb-14">
            <Reveal>
              <div data-testid="services-compliance" className="bg-white border border-line rounded-[14px] p-8 md:p-12 shadow-[0_2px_10px_rgba(23,71,95,0.05)]">
                <p className="text-xs font-bold uppercase tracking-[0.25em] text-safety mb-4">Service A</p>
                <h2 className="text-2xl md:text-4xl font-extrabold text-navy mb-6">
                  Compliance Evaluation &amp; Documentation Service
                </h2>
                <p className="text-base md:text-lg text-ink leading-relaxed mb-8 max-w-3xl">
                  "A credentialed safety professional on top of the software: we evaluate, set up, and
                  maintain your records so you stay inspection-ready."
                </p>
                <p className="text-sm text-steel leading-relaxed max-w-3xl">
                  $1,500 evaluation; then Essentials $500, Standard $1,000 or Premium $2,000 per site/month,
                  billed in addition to a Core or Pro subscription. Covers OSHA and environmental records.
                  Documentation setup is included in the setup fee; work beyond included hours is $150/hr.
                </p>
              </div>
            </Reveal>
          </section>

          <section id="consulting" className="scroll-mt-24 mb-14">
            <Reveal>
              <div data-testid="services-consulting" className="bg-white border border-line rounded-[14px] p-8 md:p-12 shadow-[0_2px_10px_rgba(23,71,95,0.05)]">
                <p className="text-xs font-bold uppercase tracking-[0.25em] text-safety mb-4">Service B</p>
                <h2 className="text-2xl md:text-4xl font-extrabold text-navy mb-6">Consulting</h2>
                <p className="text-sm text-steel leading-relaxed max-w-3xl">
                  $150/hr; $1,500 gap review; $1,500/day audit; $2,500 AI readiness assessment (credited
                  toward a paid pilot); $1,200/month retainer. No travel charge for on-site work within 50
                  miles of Abilene, Texas.
                </p>
              </div>
            </Reveal>
          </section>

          <section id="credentials" className="scroll-mt-24">
            <Reveal>
              <div data-testid="services-credentials" className="bg-wash border-2 border-safety rounded-[14px] p-8 md:p-12">
                <div className="flex items-center gap-4 mb-2">
                  <Award className="text-safety" size={26} />
                  <h2 className="text-2xl md:text-4xl font-extrabold text-navy">Sean Rawlins, founder</h2>
                </div>
                <p className="text-xs font-bold uppercase tracking-[0.25em] text-steel mb-10">
                  Individual credentials, not company certifications
                </p>
                <div className="grid sm:grid-cols-2 gap-8">
                  {CREDENTIALS.map((c) => (
                    <div key={c.source} className="border-l-[3px] border-safety pl-5">
                      <p className="text-xs font-bold uppercase tracking-[0.2em] text-safety mb-3">{c.source}</p>
                      <ul className="space-y-1.5">
                        {c.items.map((item) => (
                          <li key={item} className="text-sm text-ink">{item}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
